"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Permission = function () {
  function Permission() {}

  Object.defineProperty(Permission.prototype, "granted", {
    get: function get() {
      return this._granted;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Permission.prototype, "denied", {
    get: function get() {
      return this._denied;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Permission.prototype, "constraint", {
    get: function get() {
      return this._constraint;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Permission.prototype, "fields", {
    get: function get() {
      return this._fields || {};
    },
    enumerable: true,
    configurable: true
  });

  Permission.prototype.field = function (field) {
    if (this._granted && this._fields) {
      return Permission.testField(field, this._fields)[1];
    }

    return false;
  };

  Permission.prototype.grant = function (scopeRequest, fields, constraint) {
    if (this._granted) {
      throw new Error('Attempt to change permission grant');
    }

    this._granted = scopeRequest;
    this._fields = fields;
    this._constraint = constraint;
  };

  Permission.prototype.deny = function (scopeRequest, fields) {
    this._denied = this._denied ? this._denied : [];

    if (scopeRequest) {
      this._denied.push(scopeRequest);
    }
  };

  Permission.testField = function (field, fields) {
    if (fields.hasOwnProperty(field)) {
      return [field, fields[field]];
    } else if (fields.hasOwnProperty('*')) {
      return ['*', fields['*']];
    } else {
      return ['', false];
    }
  };

  return Permission;
}();

exports.Permission = Permission;